import { Col, Form, Row } from "react-bootstrap";
import styles from "../nfse.module.css";
import dayjs from "dayjs";

export default function IdentificacaoNFSe({ show, nota }: iProps) {
    let chave_nfs = "";
    if (nota.situacao_emissao === 100) {
        chave_nfs = String(nota.id_chave).replaceAll("NFS", "");
    }
    return (
        <div>
            <Row id={styles.identificacao_nfse} className="mb-15-forms" style={{ display: show ? "flex" : "none" }}>
                <h2 id={styles.identificacao_nfse_title}>
                    Identificação NFSe
                    {nota.ambiente_tipo === 2 && <span> - AMBIENTE HOMOLOGAÇÃO</span>}
                    {nota.situacao_importacao === 1 && <span> - Importado do Portal Contribuinte em {dayjs(nota.data_importacao).format("DD/MM/YYYY HH:mm:ss")}</span>}
                </h2>
                {nota.situacao_emissao === 100 && (
                    <Col className="col-4">
                        <Form.Group>
                            <div style={{ display: "flex", alignItems: "center", padding: "0px" }}>
                                <Form.Label>Chave de acesso <a href={`https://www.nfse.gov.br/consultapublica?tpc=1&chave=${chave_nfs}`} target="_blank" style={{ textDecoration: "none" }} rel="noreferrer">(clique para baixar)</a>:</Form.Label>
                                {nota.status === "Emitido (Cancelado)" && <p style={{ width: "auto", backgroundColor: "rgba(201, 87, 87, 0.5)", marginTop: "-10px", marginLeft: "10px", fontWeight: "bold", padding: "3px", fontSize: "0.8em" }}>CANCELADA</p>}
                            </div>
                            <Form.Control name="id_chave" type="text" id="id_chave" readOnly />
                        </Form.Group>
                    </Col>
                )}
                {nota.situacao_emissao !== 100 && (
                    <Col className="col-4">
                        <Form.Group>
                            <div style={{ display: "flex", alignItems: "center", padding: "0px" }}>
                                <Form.Label>Chave de acesso:</Form.Label>
                                {nota.status === "Emitido (Cancelado)" && <p style={{ width: "auto", backgroundColor: "rgba(201, 87, 87, 0.5)", marginTop: "-10px", marginLeft: "10px", fontWeight: "bold", padding: "3px", fontSize: "0.8em" }}>CANCELADA</p>}
                            </div>
                            <Form.Control name="id_chave" type="text" id="id_chave" readOnly />
                        </Form.Group>
                    </Col>
                )}
                <Col className="col-1">
                    <Form.Group>
                        <Form.Label>Status:</Form.Label>
                        <Form.Control name="status" type="text" id="status" defaultValue="Não Emitido" readOnly />
                    </Form.Group>
                </Col>
                <Col className="col-2">
                    <Form.Group>
                        <Form.Label>Criado em:</Form.Label>
                        <Form.Control name="data_criacao" type="text" id="data_criacao" readOnly />
                    </Form.Group>
                </Col>

                <Col className="col-2">
                    <Form.Group>
                        <Form.Label>Emitido em:</Form.Label>
                        <Form.Control name="data_emissao" type="text" id="data_emissao" readOnly />
                    </Form.Group>
                </Col>
                <Col className="col-1">
                    <Form.Group>
                        <Form.Label>Número NFSe:</Form.Label>
                        <Form.Control name="nNFSe" type="text" id="nNFSe" readOnly />
                    </Form.Group>
                </Col>
                <Col className="col-1">
                    <Form.Group>
                        <Form.Label>Número DPS:</Form.Label>
                        <Form.Control name="dps_numero" type="text" id="dps_numero" readOnly />
                    </Form.Group>
                </Col>
                <Col className="col-1">
                    <Form.Group>
                        <Form.Label>Série DPS:</Form.Label>
                        <Form.Control name="dps_serie" type="text" id="dps_serie" readOnly />
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
}
interface iProps {
    show: boolean;
    nota: any;
}
